import RibbonItem from './RibbonItem';

export default RibbonItem;